<template>
  <div>
    <v-page-toolbar :title="$t('_menu.category')" icon="collections_bookmark">
      <template v-slot:buttons>
        <v-spacer></v-spacer>

        <v-btn color="success" dark class="mb-2" @click="dialog = true">
          <v-icon dark left>add_circle_outline</v-icon>
          {{ $t("common.new").toLocaleUpperCase(lang) }} {{ $t("_menu.category").toLocaleUpperCase(lang) }}
        </v-btn>
        <new-group-button
          :dialog.sync="dialog"
          :editedItem="newItem"
          :editedIndex="itemIndex"
          :newItemStatus="newItemStatus"
          @confirmed="onConfirmed"
          @cancelled="onCancelled"
        />
      </template>
    </v-page-toolbar>

    <v-layout row wrap fluid>
      <v-flex>
        <CategoryGroupTable :value.sync="selectedGroup" />
      </v-flex>
      <!-- <v-flex lg8 sm9 xs12 v-if="selectedGroup">
        <v-card class="mx-auto">
          <v-list-item>
            <v-list-item-avatar
              color="light-blue"
              class="headline font-weight-light white--text"
              ><v-icon>{{ selectedGroup.icon }}</v-icon></v-list-item-avatar
            >
            <v-list-item-content>
              <v-list-item-title class="headline">{{
                selectedGroup.name
              }}</v-list-item-title>
              <v-list-item-subtitle
                >grubuna ait kategoriler</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
          <CategoryTable :groupId="selectedGroup.id" />
        </v-card>
      </v-flex> -->
    </v-layout>
  </div>
</template>

<script>
import CategoryGroupTable from "./CategoryGroupTable";
import CategoryTable from "../CategoriesPage/CategoryTable";
import NewGroupButton from "./NewCategoryGroupButton";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { CategoryGroupTable, CategoryTable, NewGroupButton },
  data() {
    return {
      selectedGroup: null,
      dialog: false,
      itemIndex: -1,
      enabled:false,
      newItem: {
        categoryId: null,
        name: null,
        icon: null,
        parentId: null,
        isVisible: true,
      },
      newItemStatus: true,
    };
  },
  watch: {
    $route(to, from) {
      if (to == from) {
        console.log(to);
        console.log(from);
      }
    },
    deep: true,
    immediate: true,
  },
  computed:{
    ...mapGetters({ language: "app/language" }),
    lang() {
      return this.language.replaceAll("_", "-");
    },
  },
  methods: {
    onCancelled() {
      // hide a dialog
      this.dialog = false;
    },
    onConfirmed(editedItem) {
      // hide a dialog
      this.dialog = false;
      //this.refreshTable();
      // save a user and refresh a table
    },
  },
};
</script>